module.exports = __webpack_public_path__ + "img/ear-muffs.1abbb7df.svg";